/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetTireBoundResponse } from '../models/ApiResponseGetTireBoundResponse';
import type { ApiResponseGetTireRecommendedResponse } from '../models/ApiResponseGetTireRecommendedResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateTireCommand } from '../models/CreateTireCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TireService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 사용자 차량별 타이어 등록
   * 사용자 차량별 타이어를 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createTire({
    requestBody,
  }: {
    requestBody: CreateTireCommand,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/tire/dimension',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 타이어 적정 공기압 결과 조회
   * 차종의 타이어 적정 공기압을 조회합니다.
   * @returns ApiResponseGetTireRecommendedResponse OK
   * @throws ApiError
   */
  public getTireRecommended1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetTireRecommendedResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tire/recommended',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 타이어 공기압 결과 조회
   * 타이어 공기압 결과를 조회합니다.
   * @returns ApiResponseGetTireBoundResponse OK
   * @throws ApiError
   */
  public getTireBound({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetTireBoundResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tire/bound',
      query: {
        'vin': vin,
      },
    });
  }
}
